import $ from 'jquery';

export default class Keywords {
  constructor() {
    this.$form = $('.js-keywords-form');
    this.$field = $('.js-keywords-field');
    this.$list = $('.js-keywords-list');
    this.$error = $('.js-keywords-error');

    this.state = {
      keywordList: [],
    };

    this.eventHandlers();
  }

  getList() {
    return this.state.keywordList;
  }

  clearField() {
    this.$field.val('');
  }

  checkDuplicates(list, value) {
    return list.includes(value) ? true : false;
  }

  hideError() {
    if ( !this.$error.hasClass('is-hidden') ) {
      this.$error.addClass('is-hidden');
    }
  }

  addKeyword() {
    const value = this.$field.val().trim();
    const { keywordList } = this.state;

    if ( !this.$form.valid() ) {
      return;
    }

    if ( this.checkDuplicates(keywordList, value) ) {
      this.$error.removeClass('is-hidden');

      return;
    }

    keywordList.push(value);

    // GTM
    if ( $('html').hasClass('page-med-ed') ) {
      this.pushGTMEvent(value);
    }

    $('<li class="js-keyword"></li>')
      .text(value)
      .append('<button class="js-remove-keyword-btn" type="button">X</button>')
      .prependTo(this.$list);

    this.clearField();
  }

  clear() {
    this.$list.html('');
    this.clearField();
    this.state.keywordList = [];
  }

  pushGTMEvent(value) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      'event': 'keywords-field',
      'keywords': value,
    });
  }

  eventHandlers() {
    // form submit
    this.$form.on('submit', (e) => {
      e.preventDefault();

      this.addKeyword();
    });

    // hide error when entering text
    this.$field.on('input', () => {
      this.hideError();
    });

    // remove keyword
    $(document).on('click', '.js-remove-keyword-btn', (e) => {
      e.preventDefault();

      const keyword = $(e.currentTarget).closest('.js-keyword');
      const text = keyword.contents().get(0).nodeValue;

      keyword.remove();
      this.state.keywordList = this.state.keywordList.filter(item => item !== text);

      this.hideError();
    });
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/project/keywords.class.js